<template>
  <div class="get-cloudapp-button">
    <a :href=destination v-b-modal.signup-modal id="get-cloudapp" class="cloudapp-link primary d-md-none" data-testid="get-cloudapp-button">
      <span>Sign Up</span>
    </a>

    <a :href=destination v-b-modal.signup-modal id="get-cloudapp" class="cloudapp-btn blue d-none d-md-inline" data-testid="get-cloudapp-button">
      <img :src="require('images/icon-get-cloudapp.svg')" class="mr-2 getcloudapp-icon">
      <span>Get CloudApp for Free</span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    link: { type: String }
  },
  mounted: function(){
    this.$root.$on('bv::modal::shown', (_bvEvent, modalId) => {
      if(modalId == 'signup-modal'){
        let utmParams = viewerUtmParams('nav_button_image', this.$store.state.item.id);
        setModalUTM(utmParams);
      }
    })
  },
  methods: {
    openSignupModal: function(){
      this.$bvModal.show('signup-modal')
      let utmParams = viewerUtmParams('nav_button_image', this.$store.state.item.id);
      setModalUTM(utmParams);
    }
  },
  computed: {
    destination: function() {
      return this.link ? this.link : "#"
    }
  }
}
</script>

<style scoped lang="scss">
img.getcloudapp-icon {
  height: 12
}
</style>
